import { PaymentBlock } from '../components/vdp/payment-block.vue';
Vue.component('payment-block', PaymentBlock);